// import React, { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import Loader from "react-loader";
// import Preloader from "../Components/Preloader";

// const Redirect = () => {
//   const navigate = useNavigate();
//   const location = useLocation(); // Get the current URL location
//   const [loaderState, setLoaderState] = useState(false);

//   // Extract query parameters
//   const queryParams = new URLSearchParams(location.search);
//   const correlator_id = queryParams.get("correlatorId");
//   const code = queryParams.get("code");
//   const message = queryParams.get("message");
//   const msisdn = queryParams.get("msisdn");
//   const redirect_link = window.location.href; // Capture the full URL

//   useEffect(() => {
//     console.log("Full URL:", redirect_link);
//     console.log("correlatorId:", correlator_id);
//     console.log("code:", code);
//     console.log("message:", message);
//     console.log("msisdn:", msisdn);

//     setLoaderState(true);

//     // Send data to API
//     const sendData = async () => {
//       try {
//         await axios.post("/redirectlogs", {
//           redirect_link,
//           correlator_id,
//           code,
//           message,
//           msisdn
//         });
//         console.log("Data successfully sent to API");
//       } catch (error) {
//         console.error("Error sending data:", error);
//       }
//     };

//     sendData();
//     setTimeout(() => {
//       navigate("/login"); // Redirect to the login page or any desired route
//     }, 3000);
//   }, [navigate, correlator_id, code, message, msisdn, redirect_link]);

//   let options = {
//     lines: 13,
//     length: 30,
//     width: 15,
//     radius: 30,
//     scale: 1.0,
//     corners: 1,
//     color: "#fff",
//     opacity: 0.85,
//     rotate: 0,
//     direction: 1,
//     speed: 1,
//     trail: 60,
//     fps: 20,
//     zIndex: 2e9,
//     top: "50%",
//     left: "50%",
//     shadow: false,
//     hwaccel: false,
//     position: "absolute",
//   };

//   return (
//     <div className="bg-[#1F1329] h-screen flex flex-col justify-center items-center">
//       <Loader loaded={false} options={options} className="spinner" />
//       <Preloader />
//     </div>
//   );
// };

// export default Redirect;



import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Loader from "react-loader";
import Preloader from "../Components/Preloader";
import Cookies from "js-cookie";

const Redirect = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current URL location
  const [loaderState, setLoaderState] = useState(false);

  // Extract query parameters
  const queryParams = new URLSearchParams(location.search);
  const correlator_id = queryParams.get("correlatorId");
  const code = parseInt(queryParams.get("code"), 10); // Convert to integer
  const message = queryParams.get("message");
  const msisdn = queryParams.get("msisdn");
  const redirect_link = window.location.href; // Capture the full URL

  useEffect(() => {
    console.log("Full URL:", redirect_link);
    console.log("correlatorId:", correlator_id);
    console.log("code:", code);
    console.log("message:", message);
    console.log("msisdn:", msisdn);

    setLoaderState(true);

    // Send data to API
    const sendData = async () => {
      try {
        await axios.post("/redirectlogs", {
          redirect_link,
          correlator_id,
          code,
          message,
          msisdn
        });
        console.log("Data successfully sent to API");
      } catch (error) {
        console.error("Error sending data:", error);
      }
    };

    sendData();

    // Check code and set cookies if needed
    if (code == 14 || code == -72) {
      Cookies.set("msisdn", msisdn);
      Cookies.set("status", 1);
      setTimeout(() => {
        navigate("/");
        
      }, 2000);
    } 
    else if(code==-1){
      navigate("/")
    }
    else {
      navigate("/subscribe");
    }
  }, [navigate, correlator_id, code, message, msisdn, redirect_link]);

  let options = {
    lines: 13,
    length: 30,
    width: 15,
    radius: 30,
    scale: 1.0,
    corners: 1,
    color: "#fff",
    opacity: 0.85,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    top: "50%",
    left: "50%",
    shadow: false,
    hwaccel: false,
    position: "absolute",
  };

  return (
    <div className="bg-[#1F1329] h-screen flex flex-col justify-center items-center">
      <Loader loaded={false} options={options} className="spinner" />
      <Preloader />
    </div>
  );
};

export default Redirect;
